import { Button, Stack, Typography } from "@mui/material";
import React from "react";
import { IMutator } from "sonobello.utilities.react";

export const classNames = {
  dialog: "bookingErrorConfirmationDialog",
  yesButton: "bookingErrorConfirmationYesButton",
  noButton: "bookingErrorConfirmationNoButton"
};

export interface IBookingErrorConfirmation extends IMutator<boolean> {
  customerName: string;
}

/** Displays a dialog which allows for the user to identify if they successfully booked an appointment despite detected errors. */
const BookingErrorConfirmation: React.FC<IBookingErrorConfirmation> = ({ customerName, onChange }) => {
  return (
    <Stack spacing={1}>
      <Typography variant="body1" align="center">
        {`It looks like there were errors in the Booking process.`}
      </Typography>
      <Typography className={classNames.dialog} variant="body1" align="center">
        {`Did you book an appointment for ${customerName} in Zenoti?`}
      </Typography>
      <Stack direction="row" justifyContent="center" spacing={1}>
        <Button className={classNames.yesButton} onClick={() => onChange(true)}>
          Yes
        </Button>
        <Button className={classNames.noButton} color="secondary" onClick={() => onChange(false)}>
          No
        </Button>
      </Stack>
    </Stack>
  );
};

export default BookingErrorConfirmation;
